import { render, staticRenderFns } from "./AppointmentsCreated.vue?vue&type=template&id=fa7b8c7c"
import script from "./AppointmentsCreated.vue?vue&type=script&lang=js"
export * from "./AppointmentsCreated.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsCreated.vue?vue&type=style&index=0&id=fa7b8c7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports